import { Component, NgZone, OnInit } from '@angular/core';
import { DashboardService } from '../services/dashboard.service';
import * as _ from "lodash";
import * as moment from 'moment';
import { GlobalService } from '../services/global.service';
import { SiteManagerService } from '../services/site-manager.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router, ActivatedRoute, ParamMap, NavigationStart } from '@angular/router';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatDialogConfig, MatTooltipModule, MatDialogRef } from '@angular/material'
import { AlertComponent } from '../alert/alert.component';
import { ReportService } from '../services/report.service';
import { filter } from 'rxjs/operators';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
import { runInThisContext } from 'vm';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { PopuptableComponent } from '../popuptable/popuptable.component';
import { AlertpopuptableComponent } from '../alertpopuptable/alertpopuptable.component';
import { HttpClient } from '@angular/common/http';

// @ts-ignore
import ApexCharts from 'apexcharts';
import { color } from 'highcharts';
import { RenewalWindowComponent } from '../renewal-window/renewal-window.component';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { TransformerManagerService } from '../services/transformerManager.service';
import { includes } from 'lodash';
declare let L: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  /* model */
  canvasWidth = 200;
  needleValue = 0;
  centralLabel = '';

  options = {
    hasNeedle: true,
    needleColor: 'black',
    needleUpdateSpeed: 1000,
    arcColors: ['red', 'orange', 'green'],
    arcDelimiters: [30, 50],
    rangeLabel: ['0', '100'],
    needleStartValue: 0,
  };
  textColor = "#FFFFFF"
  selectedCountry = null;
  amcexpiredtransformer: any = [];
  selectedState = null;
  selectedCity = null;
  selectedZone = null;
  selectedLocation = null;
  selectedTransformer = null;
  TransformerListForAge: any;
  ageTransformer = null;
  ageTransformerArray = null;
  windingTempArray = [];
  OilLevelArray = [];
  humidityArray = [];
  PFArray = [];
  harmonicsArray = [];
  loadArray = [];
  ratedLoadArray = [];
  vunbalanceArray = [];
  healthIndexArray = [];
  ratedLoadValue = null;
  imgPath = "../assets/images/black_transformer.png";
  currentUserData = JSON.parse(localStorage.getItem('userData'));
  data: any;
  calculatedWindingTemprature: Number = 0;
  countryList = [];
  stateList = [];
  cityList = [];
  zoneList = [];
  locationList = [];
  transformerList = [];
  healthIndex = [];
  iUnbalanceArray = [];
  weatherData = null;
  selectedTransformerForWeather = null;
  selectedTransformerForHealth = null;
  timeFilter: string;
  timeOptions: any = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
  filter: any = {};
  transformerParam: string;
  customeSelectedDate: any;
  oilTempsum = 0;
  OilTempArray: any = [];
  transformerDataForHealthIndex: any = [];
  oilTempr: any;
  oilTempValue: any;
  overallTransformerData;
  PFValue: any;
  humidityvalue: any;
  harmonicsValue: any;
  oilLevelValue: any;
  loadValue: any;
  repairedValue: any;
  iUnbalanceValue: any;
  vUnbalanceValue: any;
  windingTempValue: any;
  ageTransformerValue: any;
  ageTransformersvalue: any;
  healthOfTransformer: any;
  oilLevelValues: any;
  windingTempValues: any;
  oilTempValues: any;
  oilLevelIndicator: any;
  LoadPercentages: any = [];
  loadPercentageValue: any;
  healthColor: any;
  muteButton = "assets/images/unmute.png";
  muteFlag = 0;
  batteryStatusImgUrl = "assets/images/fullbattery.png"
  counter;
  cap = {
    radius: 5,
    border: {
      color: 'red',
      width: 3
    }
  };
  labelStyle = {
    format: '{value}°'
  };
  labelStyles = {
    format: '{value}%'
  };
  durationList = [
    { id: 1, name: 'Today' },
    { id: 2, name: 'Yesterday' },
    { id: 3, name: 'This Week' },
    { id: 4, name: 'This Month' },
    { id: 5, name: 'Last Month' },
    { id: 6, name: 'Custom' }
  ];
  selectedDuration = null;
  selectedDurationAlert = null;

  parameterList = [
    { name: 'All', value: 'all' },
    { name: 'Oil Temperature', value: 'apOiltemperature' },
    { name: 'Winding Temperature', value: 'apWindingtemperature' },
    { name: 'Overload', value: 'apOverload' },
    { name: 'Underload', value: 'apUnderload' },
    { name: 'Iunbalance', value: 'apIunbalance' },
    { name: 'Vunbalance', value: 'apVunbalance' },
    { name: 'Lowvolt', value: 'apLowvolt' },
    { name: 'Low Powerfactor', value: 'apLowPowerfactor' },
    { name: 'Oil Level', value: 'apOillevel' },
  ];

  selectedParameter = this.parameterList[0];

  redTransformerPath = '../assets/images/red_transformer.png'
  greenTransformerPath = '../assets/images/green_transformer.png'
  blackTransformerPath = '../assets/images/black_transformer.png'
  lat: number;
  lng: number;
  dataPoints = [{ lat: '20.10009154', lng: '73.011800995' }, { lat: '20.09894655', lng: '73.0174298' }]
  dataLoadProfile = []
  graphLoadProfile = {
    layout: {
      width: 500, height: 290,
      xaxis: {
        title: {
          text: 'Transformer Id',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000',
          }
        },
      },
      yaxis: {
        title: {
          text: 'Load Percentage',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000'
          }
        }
      }
    },
    config: { displaylogo: false, modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'] }
  };
  dataAlertCount = [];
  graphAlertCount = {
    layout: {
      width: 500, height: 290,
      xaxis: {
        title: {
          text: 'Date',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000',
          }
        },
      },
      yaxis: {
        title: {
          text: 'No. of Alerts',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000'
          }
        }
      }
    },
    config: { displaylogo: false, modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'] }
  };

  dataTransformerAlert = [];
  allTransformers: any = [];
  graphTransformerAlert = {
    layout: {
      width: 500, height: 290,
      xaxis: {
        title: {
          text: 'Transformer ID',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000',
          }
        },
      },
      yaxis: {
        title: {
          text: 'No. of Alerts',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000'
          }
        }
      }
    },
    config: { displaylogo: false, responsive: true, modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'] }
  };
  dashboardData;
  kvaData = null;
  kwData = null;
  kwhData = null;
  readings = [];
  countryCode: any;
  showDateRange: boolean;
  showDateRange1: boolean;
  mapData = [];
  lat1: any;
  lng1: any;
  transformerTile = null;
  latestAlertsArray = [];
  chart1;
  oilLevelGraphObject;
  lugTempGraphObject;
  healthIndexObject;
  chart2;
  chart3;
  comparision;
  showPopup: boolean = false;
  audio = new Audio();
  dialogRefas: MatDialogRef<AlertpopuptableComponent>;
  ambeintTempValues: number;
  hotSpotCalculationValue: any;
  jiouser = false;
  dataforHealthIndex: any;
  deviceConnectionStatus: any;
  averageHealth: any;
  Unhealthy: any;
  Healthy: any;
  completeMaintenanceCount: any = 0;
  pendingMaintenanceCount: any = 0;
  completeMaintenanceData: any = 0;
  pendingMaintenanceData: any = 0;
  maxTransformerId: any;
  maxDemand: any = 0;
  maxDemandValue: any = 0;
  averageDemand: any = 0;
  warningDataArray: any = [];
  socket = new WebSocket('wss://api.trafobola.com');
  map: any;
  constructor(private zone: NgZone, private _dashboardService: DashboardService, private globalService: GlobalService, private reportService: ReportService, private trnsfrmr: TransformerManagerService,
    private sitemanagerService: SiteManagerService, private http: HttpClient, private route: ActivatedRoute, private ngxLoader: NgxUiLoaderService, private router: Router, private matDialog: MatDialog) {

  }

  ngOnInit() {
    if (this.currentUserData.userid == 283) {
      this.jiouser = true;
    }

    this.globalService.countrySelection(this.currentUserData.countryid).subscribe((response: any) => {
      this.countryCode = response.result[0].code;
      this.ngxLoader.startLoader('healthIndexArray');
      this.globalService.golbalMaster('country').subscribe((response: any) => {
        this.countryList = response.result;
        this.selectedCountry = _.find(this.countryList, (o: any) => {
          return o.code === this.countryCode;
        });
        this.countrySelection();
        this.getLatLang();


        this.getMaintenancePlanningData();
        this.getHealthIndex();
      });
    });
    this.timeFilter = 'Today';

  }
  ngOnDestroy() {
    console.log('Dashboard destroyed, stopping audio');
    if (this.socket) {
      this.socket.close();
    }
    this.audio.pause();
    this.audio.currentTime = 0;
  }

  transformerStatusGraph() {
    console.log("abcd ", this.transformerTile)
    const seriesData = [this.transformerTile.onlineTransformer, this.transformerTile.offlineTransformer, this.transformerTile.alertTransformer, this.transformerTile.normalTransformer];
    const total = seriesData.reduce((a, b) => a + b, 0);

    var options = {
      series: seriesData,
      chart: {
        height: "100%",
        type: 'donut',
        events: {
          legendClick: (chartContext, seriesIndex) => {
            const legendName = options.labels[seriesIndex];
            this.popupTable(legendName, '');
          }
        },
      },
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 270,
          donut: {
            size: '65%',
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: '2vh',
                color: this.textColor,
                offsetY: -10,
              },
              value: {
                show: true,
                fontSize: '2.5vh',
                fontWeight: 600,
                color: this.textColor,
                offsetY: -1,
                formatter: () => `${this.transformerTile.totalTransformer}`,
              },
              total: {
                show: true,
                label: 'Total',
                fontSize: '1.5vh',
                fontWeight: 600,
                color: this.textColor,
                formatter: () => `${this.transformerTile.totalTransformer}`,
              },
            },
          },
        },
      },
      colors: ["#008000", "#808080", "#ff0000", "#00ffec"],
      labels: ["online", "offline", "alert", "normal"],
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: 'gradient',
      },
      legend: {
        position: 'right',
        formatter: function (val, opts) {
          return `<span style="font-weight: bolder; cursor: pointer;">${val} :<b style="font-size:2vh;"> ${opts.w.globals.series[opts.seriesIndex]}</b></span>`;
        },
        labels: {
          useSeriesColors: true, // Set to true to use slice/bar colors
        },
      },
      title: {
        text: 'Transformer Status',
        align: 'center',
        style: {
          color: this.textColor
        }
      },

    };

    var chart = new ApexCharts(document.querySelector("#transformerStatus"), options);
    chart.render();
  }
  deviceStatus(connected, disconnected) {
    console.log("abcd ", connected)
    const seriesData = [connected, disconnected];
    var options = {
      series: seriesData,
      chart: {
        height: "100%",
        type: 'pie',
        events: {
          legendClick: (chartContext, seriesIndex) => {
            const legendName = options.labels[seriesIndex];
            this.popupTable(legendName, this.deviceConnectionStatus);
          }
        },
      },

      colors: ["#008000", "#808080"],
      labels: ["Connected", "Disconnected"],
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: 'gradient',
      },
      legend: {
        position: 'right',
        formatter: function (val, opts) {
          // Add the image only for "disconnected" legend item
          if (val.toLowerCase() === "disconnected") {
            return `<span style="font-weight: bolder; cursor: pointer;">
            ${val} :<b style="font-size:2vh;"> ${opts.w.globals.series[opts.seriesIndex]}</b><br>
            <img src="assets/images/connection.gif" height="40" width=60" style="margin-left: 20%;margin-top:10%">
          </span>`;
          }
          return `<span style="font-weight: bolder; cursor: pointer;">
          ${val} :<b style="font-size:2vh;"> ${opts.w.globals.series[opts.seriesIndex]}</b>
        </span>`;
        },
        labels: {
          useSeriesColors: true,
        },
      },
      title: {
        text: 'Last 2 Days Connection Status',
        align: 'center',
        style: {
          color: this.textColor
        }
      },

    };

    var chart = new ApexCharts(document.querySelector("#deviceStatus"), options);
    chart.render();
  }

  alertStatus() {
    let alertArray = ["apOiltemperature", "apWindingtemperature", "apVunbalance", "apIunbalance", "apLowvolt", "apHighvolt", "apLowPowerfactor", "apUnderload", "apOverload"];

    // Initialize an object to store the total count for each alert, setting all counts to 0 initially
    let totalAlertCount: { [key: string]: number } = {};
    alertArray.forEach(alert => {
      totalAlertCount[alert] = 0;  // Initialize each alert parameter with a count of 0
    });

    // Loop through each transformer in overallTransformerData.result
    this.overallTransformerData.result.forEach(element => {
      // Loop through each alert in the current transformer
      element.alert.forEach(alertItem => {
        // Check if the alert's parametername is in the alertArray
        if (alertArray.includes(alertItem.parametername)) {
          // Increment the count for that parameter
          totalAlertCount[alertItem.parametername]++;
        }
      });
    });

    // After processing all transformers, log the total alert count for each parameter
    console.log("Total alert counts across all transformers:", totalAlertCount);

    const alertMapping = {
      apOiltemperature: "Oil Temp",
      apWindingtemperature: "Wind Temp",
      apVunbalance: "V Unbalance",
      apIunbalance: "I Unbalance",
      apLowvolt: "Low Volt",
      apHighvolt: "High Volt",
      apLowPowerfactor: "Low PF",
      apUnderload: "Underload",
      apOverload: "Overload"
    };

    var options = {
      series: [{
        name: "Alerts",
        data: [
          { x: alertMapping["apOiltemperature"], y: totalAlertCount.apOiltemperature, alertName: "apOiltemperature" },
          { x: alertMapping["apWindingtemperature"], y: totalAlertCount.apWindingtemperature, alertName: "apWindingtemperature" },
          { x: alertMapping["apVunbalance"], y: totalAlertCount.apVunbalance, alertName: "apVunbalance" },
          { x: alertMapping["apIunbalance"], y: totalAlertCount.apIunbalance, alertName: "apIunbalance" },
          { x: alertMapping["apLowvolt"], y: totalAlertCount.apLowvolt, alertName: "apLowvolt" },
          { x: alertMapping["apHighvolt"], y: totalAlertCount.apHighvolt, alertName: "apHighvolt" },
          { x: alertMapping["apLowPowerfactor"], y: totalAlertCount.apLowPowerfactor, alertName: "apLowPowerfactor" },
          { x: alertMapping["apUnderload"], y: totalAlertCount.apUnderload, alertName: "apUnderload" },
          { x: alertMapping["apOverload"], y: totalAlertCount.apOverload, alertName: "apOverload" }
        ]
      }],
      chart: {
        type: 'bar',
        height: "100%",
        events: {
          dataPointSelection: (event, chartContext, config) => {
            const selectedData = config.w.config.series[config.seriesIndex].data[config.dataPointIndex];
            const alertName = selectedData.alertName;
            this.popupTable(alertName, 'alertDataSelected'); // Call the function with the correct parameters
          }
        },
        toolbar: {
          show: false
        },
        minBarHeight: 10, // Increase this value to make bars more clickable
      },
      colors: ['#FF6347', '#1E90FF', '#32CD32', '#FFD700', '#FF4500', '#8A2BE2', '#20B2AA', '#FF1493', '#FF8C00'],
      xaxis: {
        type: 'category',
        labels: {
          style: {
            colors: this.textColor,
            fontSize: '1.5vh'
          },
          rotate: 0,
        },
      },
      yaxis: {
        show: false,
        labels: {
          show: false
        },
      },
      title: {
        text: 'Alert Status',
        align: 'center',
        style: {
          color: this.textColor
        }
      },
      grid: {
        show: false
      },
      tooltip: {
        style: {
          color: "#1E90FF"
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          columnWidth: '80%',
          dataLabels: {
            position: 'top',
            style: {
              colors: ['#000000'] // Color of the value text (make it stand out)
            }
          }
        }
      }
    };

    var chart = new ApexCharts(document.querySelector("#alertStatus"), options);
    chart.render();


  }
  healthStatus(average, unhealthy, healthy) {
    console.log("abcd ", this.transformerTile)

    const seriesData = [healthy, average, unhealthy];
    var options = {
      series: seriesData,
      chart: {
        height: "100%",
        type: 'pie',
        events: {
          legendClick: (chartContext, seriesIndex) => {
            const legendName = options.labels[seriesIndex];
            this.popupTable(legendName, '');
          }
        },
      },

      colors: ["#3aff00", "#ffdc2f", "#ff0000"],
      labels: ["Healthy", "Average", "Unhealthy"],
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: 'gradient',
      },
      legend: {
        position: 'right',
        formatter: function (val, opts) {
          // Add the image only for "disconnected" legend item

          return `<span style="font-weight: bolder; cursor: pointer;">
          ${val} :<b style="font-size:2vh;"> ${opts.w.globals.series[opts.seriesIndex]}</b>
        </span>`;
        },
        labels: {
          useSeriesColors: true,
        },
      },
      title: {
        text: 'Health Status Of Transformers',
        align: 'center',
        style: {
          color: this.textColor,
        }
      },

    };

    var chart = new ApexCharts(document.querySelector("#healthStatus"), options);
    chart.render();
  }
  loadAverageGraph(average) {
    var options = {
      series: [average],
      chart: {
        height: '100%',
        padding: 0,
        type: 'radialBar',
        offsetY: 0
      },

      plotOptions: {
        radialBar: {
          startAngle: -160,
          endAngle: 160,
          dataLabels: {
            name: {
              fontSize: '1.5vh',
              color: '#00ffbf',
              offsetY: '-5%'
            },
            value: {
              offsetY: 0,
              fontSize: '2.5vh',
              color: '#00ffbf',
              formatter: function (val) {
                return val + "%";
              }
            }
          }
        }
      },
      fill: {
        colors: ['#00ffbf'], // Red for values 60 and above
        type: 'gradient',
        gradient: {
          shade: 'dark',
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          //stops: [0, 50, 65, 91]
        },

      },
      stroke: {
        dashArray: 2
      },
      labels: ['Load'],
      grid: {
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }
    };

    let chart = new ApexCharts(document.querySelector("#loadAverage"), options);
    chart.render();
  }
  peakLoadGraph(peakLoad) {
    var options = {
      series: [peakLoad],
      chart: {
        height: '100%',
        padding: 0,
        type: 'radialBar',
        offsetY: 0
      },

      plotOptions: {
        radialBar: {
          startAngle: -160,
          endAngle: 160,
          dataLabels: {
            name: {
              fontSize: '1.5vh',
              color: '#ff2f2f',
              offsetY: '-10%'
            },
            value: {
              offsetY: 0,
              fontSize: '2.5vh',
              color: '#ff2f2f',
              formatter: function (val) {
                return `${val}%`;
              }
            }
          }
        }
      },
      fill: {
        colors: ['#ff2f2f'], // Red for values 60 and above
        type: 'gradient',
        gradient: {
          shade: 'dark',
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          //stops: [0, 50, 65, 91]
        },

      },
      stroke: {
        dashArray: 0
      },
      labels: ['Load'],
      grid: {
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }
    };

    let chart = new ApexCharts(document.querySelector("#peakLoad"), options);
    chart.render();
  }
  alertCheck(data, a) {
    console.log(data)
  }
  fetchLatestAlertData(transformerIdsArray) {
    //{userid:this.currentUserData.userid,roleid:this.currentUserData.roleid}
    this.audio.src = "assets/sound/alertsound.mp3";


    this.socket.onopen = () => console.log('✅ WebSocket connected');
    this.socket.onerror = (e) => console.error('❌ WebSocket error:', e);

    this.socket.onmessage = (event) => {
      this.zone.runOutsideAngular(() => {
        try {
          const msg = JSON.parse(event.data);
          let newArray = [];
          if (msg.type == "alertQueue") {
            msg.data.forEach(data => {
              newArray = [];
              if (transformerIdsArray.includes(data.transformerid)) {
                if (data.parametername != 'apOillevel') {
                  data.gparametervalue = data.gparametervalue
                }
                newArray.push(data);
                this.latestAlertsArray.push(data);
                if (this.dialogRefas && this.dialogRefas.componentInstance) {
                  this.dialogRefas.componentInstance.data.newData = data;
                }
              }
            })
            if (this.currentUserData.userid == 196 && newArray.length > 0) {
              this.audio.load();
              this.audio.play();
            }
          }

        } catch (err) {
          console.error('❌ Error parsing data:', err);
        }
      });
    };
  }
  OilTempGraph(value) {
    var options = {
      series: [value],
      chart: {
        height: '100%',
        width: '100%',
        padding: 0,
        type: 'radialBar',
        offsetY: 0
      },
      title: {
        text: 'Oil Temperature',
        align: 'center',
        style: {

          fontWeight: 'bold',
          color: '#333'
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -160,
          endAngle: 160,
          dataLabels: {
            name: {
              fontSize: '70%',
              color: '#964B00',
              offsetY: '-5%'
            },
            value: {
              offsetY: 0,
              fontSize: '100%',
              color: 'black',
              formatter: function (val) {
                return val + "°C";
              }
            }
          }
        }
      },
      fill: {
        colors: ['#f75431'], // Red for values 60 and above
        type: 'gradient',
        gradient: {
          shade: 'dark',
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 0.1,
          //stops: [0, 50, 65, 91]
        },

      },
      stroke: {
        dashArray: 3
      },
      labels: ['Oil Temp'],
      grid: {
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }
    };

    this.chart1 = new ApexCharts(document.querySelector("#oilTemp"), options);
    this.chart1.render();
  }
  comparisionGraph() {
    var options = {
      series: [{
        name: 'Oil Temp',
        data: []
      }, {
        name: 'Winding Temp',
        data: []
      }],
      chart: {
        height: "100%",
        width: "100%",
        type: 'area'
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },

      title: {
        text: '.',
        align: 'left'
      },
      xaxis: {
        type: 'DateTime',
        tickAmount: 2.2,
        tickPlacement: 'between',
        intervalType: 'Hours',
        labels: {
          show: true,
          style: {
            colors: 'black',
            fontWeight: 'bold'
          },
          rotate: 0,
        },
        categories: []
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        floating: true,
        offsetY: -25,
        offsetX: -5
      },

    };
    this.comparision = new ApexCharts(document.querySelector("#comparision"), options);
    this.comparision.render();
  }
  WindTempGraph() {
    var options = {
      series: [0],
      chart: {
        height: '100%',
        //width:'100%',
        padding: 0,
        type: 'radialBar',
        offsetY: 0
      },
      title: {
        text: 'Winding Temperature',
        align: 'center',
        style: {

          fontWeight: 'bold',
          color: '#333'
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -160,
          endAngle: 160,
          dataLabels: {
            name: {
              fontSize: '70%',
              color: '#964B00',
              offsetY: '-5%'
            },
            value: {
              offsetY: 0,
              fontSize: '100%',
              color: 'black',
              formatter: function (val) {
                return val + "°C";
              }
            }
          }
        }
      },
      fill: {
        colors: ['#FF4500'], // Red for values 60 and above
        type: 'gradient',
        gradient: {
          shade: 'dark',
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 0.1,
          //stops: [0, 50, 65, 91]
        },

      },
      stroke: {
        dashArray: 1
      },
      labels: ['Winding Temp'],
      grid: {
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }
    };

    this.chart2 = new ApexCharts(document.querySelector("#windTemp"), options);
    this.chart2.render();
  }
  loadperGraph() {
    var options = {
      series: [0],
      chart: {
        height: '100%',
        width: '100%',
        padding: 0,
        type: 'radialBar',
        offsetY: 0
      },
      title: {
        text: 'Load Percentege',
        align: 'center',
        style: {

          fontWeight: 'bold',
          color: '#333'
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -160,
          endAngle: 160,
          dataLabels: {
            name: {
              fontSize: '70%',
              color: '#964B00',
              offsetY: '-5%'
            },
            value: {
              offsetY: 0,
              fontSize: '100%',
              color: 'black',
              formatter: function (val) {
                return val + " %";
              }
            }
          }
        }
      },
      fill: {
        colors: ['#0B5345'], // Red for values 60 and above
        type: 'gradient',
        gradient: {
          shade: 'dark',
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 0.1,
          //stops: [0, 50, 65, 91]
        },

      },
      stroke: {
        dashArray: 5
      },
      labels: ['Load %'],
      grid: {
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }
    };

    this.chart3 = new ApexCharts(document.querySelector("#loadper"), options);
    this.chart3.render();
  }
  oilLevel(value) {

    var options = {
      series: [value],
      chart: {
        height: '100%',
        width: '100%',
        type: 'radialBar',
        offsetY: 0
      },
      title: {
        text: 'Oil Level',
        align: 'center',
        style: {

          fontWeight: 'bold',
          color: '#333'
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -160,
          endAngle: 160,
          dataLabels: {
            name: {
              fontSize: '70%',
              color: '#964B00',
              offsetY: '-5%'
            },
            value: {
              offsetY: 0,
              fontSize: '100%',
              color: 'black',
              formatter: function (val, opts) {
                return 'No Data';
              }
            }
          }
        }
      },

      colors: ['blue'],

      stroke: {
        dashArray: 0
      },
      labels: ['Oil Level'],
      grid: {
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }
    };

    this.oilLevelGraphObject = new ApexCharts(document.querySelector("#oilLevel"), options);
    this.oilLevelGraphObject.render();
  }
  lugTemp() {
    var options = {
      series: [0, 0, 0],
      chart: {
        height: 'auto',
        width: '100%',
        type: 'radialBar',
      },
      title: {
        text: 'Lug Temperature',
        align: 'center',
        style: {

          fontWeight: 'bold',
          color: '#333'
        }
      },
      plotOptions: {
        radialBar: {
          offsetY: 0,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 5,
            size: '30%',
            background: 'transparent',
            image: undefined,
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
            }
          }
        }
      },
      colors: ['#FF0101', '#D3E129', '#019BFF'],
      labels: ['R-Phase', 'Y-Phase', 'B-Phase'],
      legend: {
        show: true,
        floating: true,
        fontSize: '12%',
        position: 'left',
        //offsetX: 20,
        offsetY: 27,
        labels: {
          useSeriesColors: true,
        },
        markers: {
          size: 0
        },
        formatter: function (seriesName, opts) {
          return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "°C"
        },
        itemMargin: {
          vertical: 0
        },
        grid: {
          padding: {
            top: 0,
            right: '2%',
            bottom: 0,
            left: 0
          }
        }
      },
      stroke: {
        dashArray: 0
      },
      responsive: [{
        breakpoint: 480,
        options: {
          legend: {
            show: false
          }
        }
      }]
    };

    this.lugTempGraphObject = new ApexCharts(document.querySelector("#lugTemp"), options);
    this.lugTempGraphObject.render();
  }
  healthIndexData() {
    var options = {
      series: [0],
      chart: {
        height: '100%',
        width: '100%',
        type: 'radialBar',
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -135,
          endAngle: 225,
          hollow: {
            margin: 0,
            size: '70%',
            background: '#fff',
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: 'front',
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.24
            }
          },
          track: {
            background: '#fff',
            strokeWidth: '67%',
            margin: 0, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35
            }
          },

          dataLabels: {
            show: true,
            name: {
              offsetY: 0,
              show: true,
              color: '#596271',
              fontSize: '80%'
            },
            value: {
              formatter: function (val) {
                return val + "%";
              },
              color: 'green',
              fontSize: '130%',
              show: true,
            }
          }
        }
      },
      fill: {
        colors: ["#800020"],
      },

      stroke: {
        lineCap: 'round'
      },
      labels: ['Health Index'],
    };

    this.healthIndexObject = new ApexCharts(document.querySelector("#healthIndex"), options);
    this.healthIndexObject.render();
  }

  getHealthIndex() {
  this._dashboardService.gethealthSatus({
    userid: this.currentUserData.userid,
    roleid: this.currentUserData.roleid
  }).subscribe((response: any) => {
    console.log("health response", response);

    let transformers: any[] = [];

    if (this.currentUserData.roleid !== 1) {
      // Non-admin → only Active transformers
      transformers = response.result.filter(v => v.amc_status === "Active");
    } else {
      // Admin → use all transformers
      transformers = response.result;
    }

    this.averageHealth = transformers
      .filter(v => v.health_status === "Average")
      .map(v => v.transformerid);

    this.Unhealthy = transformers
      .filter(v => v.health_status === "Unhealthy")
      .map(v => v.transformerid);

    this.Healthy = transformers
      .filter(v => v.health_status === "Healthy")
      .map(v => v.transformerid);

    this.healthStatus(
      this.averageHealth.length,
      this.Unhealthy.length,
      this.Healthy.length
    );
  });
}


  getMaintenancePlanningData() {
    this.trnsfrmr.getMaintenancePlanningData({ userid: this.currentUserData.userid }).subscribe((response: any) => {
      console.log("Maintenance data", response);
      if (response.data.length > 0) {
        this.completeMaintenanceData = response.data.filter(value => value.status == "Complete").map(data => data.transformerid);
        this.pendingMaintenanceData = response.data.filter(value => value.status == "Pending").map(data => data.transformerid);
        this.completeMaintenanceCount = this.completeMaintenanceData.length;
        this.pendingMaintenanceCount = this.pendingMaintenanceData.length;
      }
    });

  }
  getLatLang() {
    let countryid = this.currentUserData.countryid;
    if (countryid == 100) {
      this.lat1 = 20.5937;
      this.lng1 = 78.9629;
    } else if (countryid == 162) {
      this.lat1 = 9.0820;
      this.lng1 = 8.6753;
    } else if (countryid == 232) {
      this.lat1 = 40.147844308078014;
      this.lng1 = -101.23596925926525;
    } else if (countryid == 111) {
      this.lat1 = 36.52430154315737;
      this.lng1 = 139.42371318237787;
    }

  }
  openAlertBox() {
    let dialogRef: any;
    const dialogConfig = new MatDialogConfig();

    dialogRef = this.matDialog.open(AlertComponent, {
      autoFocus: false,
      height: '600px', width: '700px', data: { "details": "", "action": "Add" }, panelClass: 'custom-modalbox'
    });
    dialogRef.updatePosition({ top: '50px', right: '10px' });

  }

  filtertransformerPayload() {
    let payloadtogetTransformer = {
      "countryid": this.selectedCountry ? this.selectedCountry.id : null,
      "stateid": this.selectedState ? this.selectedState.id : null,
      "cityid": this.selectedCity ? this.selectedCity.id : null,
      "zoneid": this.selectedZone ? this.selectedZone.id : null,
      "locationid": this.selectedLocation ? this.selectedLocation.id : null,
      "transformerid": this.selectedTransformer ? this.selectedTransformer.transformerid : null,
    }
    return payloadtogetTransformer;
  }

  getListofTransformerInitial() {
    let payloadtogetTransformer = {
      "countryid": this.selectedCountry ? this.selectedCountry.id : null,
      "stateid": null,
      "cityid": null,
      "zoneid": null,
      "locationid": null,
      "transformerid": null,
    };
    this.globalService.getfilteredTransformers(JSON.stringify(payloadtogetTransformer), localStorage.getItem('userData')).subscribe((response: any) => {
      if (response && response.code === '1' && response.result.length > 0) {
        this.transformerList = response.result;
        this.transformerList.map(e => {
          e.label = `${e.transformerid}[ ${e.sitename} ]`;
        });
      }
    })
  }

  countrySelection() {
    this.stateList = [];
    this.cityList = [];
    this.zoneList = [];
    this.locationList = [];
    this.filteredTransformers()
    if (this.selectedCountry) {
      this.globalService.getStateList(this.selectedCountry).subscribe((response: any) => {
        if (response && response.code === '1') {
          this.stateList = response.result;
        }
      });
    }
  }

  stateSelection() {
    this.cityList = [];
    this.zoneList = [];
    this.locationList = [];
    if (this.selectedState) {
      this.globalService.getCityList(this.selectedState).subscribe((response: any) => {
        if (response && response.code === '1') {
          this.cityList = response.result;
        }
      });
    } else {
      this.selectedCity = null;
      this.selectedZone = null;
      this.selectedLocation = null;
    }
    this.filteredTransformers();
  }

  citySelection() {
    this.zoneList = [];
    this.locationList = [];
    if (this.selectedCity) {
      this.globalService.getZoneList(this.selectedCity).subscribe((response: any) => {
        if (response && response.code === '1') {
          this.zoneList = response.result;
        }
      });
    } else {
      this.selectedZone = null;
      this.selectedLocation = null;
    }
    this.filteredTransformers();
  }

  zoneSelection() {
    this.locationList = [];
    if (this.selectedZone) {
      this.globalService.getSiteLocationList(this.selectedZone).subscribe((response: any) => {
        if (response && response.code === '1') {
          this.locationList = response.result;
        }
      });
    } else {
      this.selectedLocation = null;
    }
    this.filteredTransformers();
  }

  locationSelection() {
    this.filteredTransformers();
  }

  transformerSelection() {
    this.filteredTransformers();
  }

  onMouseOver(infoWindow, gm) {
    if (gm.lastOpen && gm.lastOpen.isOpen) {
      gm.lastOpen.close();
    }
    gm.lastOpen = infoWindow;
    infoWindow.open();
  }

  transformerClicked(data) {
    console.log("data++", data)
    //data = 'T-1152';
    this.router.navigate(['/report'], { queryParams: { transformerId: data.transformerid } });

  }

  async filteredTransformers() {
    this.ngxLoader.startLoader('dashboard');
    let temptransformerList = [];
    let deviceList = [];
    this.kvaData = null;
    this.kwData = null;
    this.kwhData = null;
    let payloadtogetTransformer = this.filtertransformerPayload();
    console.log("filtered response===payloadtogetTransformer==========>", localStorage.getItem('userData'))
    let userData = await localStorage.getItem('userData');
    this.globalService.getfilteredTransformers(JSON.stringify(payloadtogetTransformer), userData).subscribe((response: any) => {
      console.log("user Data===", response)
      if (response && response.code == '1' && response.result.length > 0) {
        this.ngxLoader.stopLoader('dashboard');
        console.log("filtered response=============>", response.result[0]);
        this.allTransformers = response.result;
        let tempdata = response.result;
        if (this.currentUserData.roleid !== 1) {
          console.log("Not Super Admin")
          const hasActive = tempdata.some(t => t.amc_status === "Active");
          this.amcexpiredtransformer = tempdata
            .filter(t => t.amc_status === "Expired")
            .map(t => t.transformerid
            );
          this.getLastUpdatedAlertsData();
          if (hasActive) {
            this.transformerList = tempdata.filter(t => t.amc_status === "Active");
          } else {
            this.transformerList = tempdata;
          }
        } else {
          this.transformerList = tempdata;
        }

        this.transformerList.map(e => {
          e.label = `${e.transformerid}[ ${e.sitename} ]`;
        });
        for (let i = 0; i < this.transformerList.length; i++) {
          temptransformerList.push(this.transformerList[i].transformerid);
          deviceList.push(this.transformerList[i].deviceId)
        }
        console.log("Transformer Parameters", temptransformerList);
        if (this.currentUserData.roleid !== 1) {
          this.getRenewalData();
        }

        /* Method For Populating Tiles Count */
        this.getMapData(temptransformerList, deviceList);
        this.fetchLatestAlertData(temptransformerList);
        /* Method to Load Profile */
        this.loadProfile(temptransformerList);
        /* Method For Alert Count */
        const dates = this.generatesDatesForAlert();
        let currentDatealert = {
          startdate: moment().startOf('month').format('YYYY-MM-DD'),
          enddate: moment().endOf('month').format('YYYY-MM-DD')
        };
        this.selectedDurationAlert = this.durationList[3];
        //this.alertCount(currentDatealert);
        /* Method For Weather Load */
        this.selectedTransformerForWeather = this.transformerList[0];
        this.selectedTransformerForHealth = this.transformerList[0];
        this.getWeatherData(this.transformerList[0]);
        /* Method For Transformer Alert */
        let currentDate = {
          startdate: moment().format('YYYY-MM-DD'),
          enddate: moment().format('YYYY-MM-DD')
        };
        this.selectedDuration = this.durationList[0];
        // this.getTransformerAlert(currentDate);


      } else {
        this.ngxLoader.stopLoader('dashboard');
        this.transformerTile = null;
        this.kvaData = null;
        this.kwData = null;
        this.kwhData = null;

        this.dataLoadProfile = [];
        this.dataAlertCount = [];
        this.mapData = [];
        this.selectedTransformerForWeather = null;
        this.selectedTransformerForHealth = null;
        this.weatherData = null;
        this.dataTransformerAlert = [];
      }
    }, (error) => {
      this.ngxLoader.stopLoader('dashboard');
    });
  }

  parameterChange(selectedParameter) {
    this.durationSelectionAlert(this.selectedDuration, 'talert');
  }

  changeDateRange(event) {
    console.log("event----------", event)
    if (this.showDateRange) {
      let date = {
        startdate: moment(event.value[0]).format('YYYY-MM-DD'),
        enddate: moment(event.value[1]).format('YYYY-MM-DD')
      };
      // this.getTransformerAlert(date);
    }
  }

  changeDateRange1(event) {
    console.log("event----------", event)
    if (this.showDateRange1) {
      let date = {
        startdate: moment(event.value[0]).format('YYYY-MM-DD'),
        enddate: moment(event.value[1]).format('YYYY-MM-DD')
      };
      this.alertCount(date);
    }
  }
  makePayment() {
    // You should replace the following URL with your server-side endpoint
    const serverEndpoint = 'makePayment';

    this.http.post(serverEndpoint, {}).subscribe(
      (response: any) => {
        // Redirect the user to the payment gateway URL received from the server
        window.location.href = response.paymentUrl;
      },
      (error) => {
        console.error('Error making payment:', error);
      }
    );
  }
  durationSelectionAlert(selectedDuration, type) {
    console.log('selectedDuration====', selectedDuration)
    let date = {
      startdate: moment().format('YYYY-MM-DD'),
      enddate: moment().format('YYYY-MM-DD')
    };
    if (selectedDuration.id == 2) {
      date.startdate = moment().subtract(1, 'day').format('YYYY-MM-DD');
      date.enddate = moment().subtract(1, 'day').format('YYYY-MM-DD')
    }
    if (selectedDuration.id == 3) {
      date.startdate = moment().startOf('week').format('YYYY-MM-DD');
      date.enddate = moment().endOf('week').format('YYYY-MM-DD');
    }
    if (selectedDuration.id == 4) {
      date.startdate = moment().startOf('month').format('YYYY-MM-DD');
      date.enddate = moment().endOf('month').format('YYYY-MM-DD');
    }
    if (selectedDuration.id == 5) {
      date.startdate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      date.enddate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    }
    if (selectedDuration.id == 6 && type === 'talert') {
      this.showDateRange = true;
    } else if (type === 'talert') {
      this.showDateRange = false;
    }

    if (selectedDuration.id == 6 && type === 'alert') {
      this.showDateRange1 = true;
    } else if (type === 'alert') {
      this.showDateRange1 = false;
    }

    if (type === 'talert' && selectedDuration.id != 6) {
      this.getTransformerAlert(date);
    } else if (selectedDuration.id != 6) {
      this.alertCount(date);
    }

  }

  getTransformerAlert(date) {
    this.dataTransformerAlert = [];
    let temptransformerList = [];
    for (let i = 0; i < this.transformerList.length; i++) {
      temptransformerList.push(this.transformerList[i].transformerid);
    }
    this.ngxLoader.startLoader('dataTransformerAlert');
    this._dashboardService.transformerCount({ daterange: JSON.stringify(date), transformerList: temptransformerList, parameter: this.selectedParameter.value }).subscribe((response: any) => {
      console.log("response==getTransformerAlert======", response)
      if (response && response.result && response.result.length > 0) {
        this.ngxLoader.stopLoader('dataTransformerAlert');
        const count = _.map(response.result, 'count');
        const transformers = _.map(response.result, 'transformerid');
        const sitename = _.map(response.result, 'sitename');
        this.dataTransformerAlert = [{ x: transformers, y: count, text: sitename, type: 'bar' }];
      } else {
        this.ngxLoader.stopLoader('dataTransformerAlert');
      }
    }, (error) => {
      this.ngxLoader.stopLoader('dataTransformerAlert');
    })
  }

  generatesDatesForAlert() {
    let resultdates = [];
    let n = 7;
    let current = moment();
    while (n > 0) {
      resultdates.push(current.format('YYYY-MM-DD'))
      current.subtract(1, 'day');
      n--;
    }
    console.log("filtered resultdates=============>", resultdates)
    return resultdates;
  }

  alertCount(date) {
    this.dataAlertCount = [];
    let temptransformerList = [];
    for (let i = 0; i < this.transformerList.length; i++) {
      temptransformerList.push(this.transformerList[i].transformerid);
    }
    this.ngxLoader.startLoader('dataAlertCount');
    this._dashboardService.alertCount({ dates: JSON.stringify(date), transformerList: temptransformerList }).subscribe((response: any) => {
      console.log("response=====alertCount===", response)
      if (response && response.result && response.result.length > 0) {
        this.ngxLoader.stopLoader('dataAlertCount');
        let dataAlercount = response.result;
        let apOverload = _.find(dataAlercount, (o: any) => {
          return o.type === 'apOverload'
        })
        var trace1 = {
          x: apOverload.date,
          y: apOverload.count,
          name: 'Overload',
          type: 'bar'
        };
        let apIunbalance = _.find(dataAlercount, (o: any) => {
          return o.type === 'apIunbalance'
        })
        var trace2 = {
          x: apIunbalance.date,
          y: apIunbalance.count,
          name: 'I Unbalance',
          type: 'bar'
        };
        let apOiltemperature = _.find(dataAlercount, (o: any) => {
          return o.type === 'apOiltemperature'
        })
        var trace3 = {
          x: apOiltemperature.date,
          y: apOiltemperature.count,
          name: 'Oil Temperature',
          type: 'bar'
        };
        let apUnderload = _.find(dataAlercount, (o: any) => {
          return o.type === 'apUnderload'
        })
        var trace4 = {
          x: apUnderload.date,
          y: apUnderload.count,
          name: 'Underload',
          type: 'bar'
        };

        let apLowPowerfactor = _.find(dataAlercount, (o: any) => {
          return o.type === 'apLowPowerfactor'
        })
        var trace5 = {
          x: apLowPowerfactor.date,
          y: apLowPowerfactor.count,
          name: 'LowPowerfactor',
          type: 'bar'
        };

        let apWindingTemperature = _.find(dataAlercount, (o: any) => {
          return o.type === 'apWindingTemperature'
        })
        var trace6 = {
          x: apWindingTemperature.date,
          y: apWindingTemperature.count,
          name: 'WindingTemperature',
          type: 'bar'
        };

        let apOillevel = _.find(dataAlercount, (o: any) => {
          return o.type === 'apOillevel'
        })
        var trace7 = {
          x: apOillevel.date,
          y: apOillevel.count,
          name: 'Oillevel',
          type: 'bar'
        };

        this.dataAlertCount = [trace1, trace2, trace3, trace4, trace5, trace6, trace7]
        console.log("this.dataAlertCount============", this.dataAlertCount)
      } else {
        this.ngxLoader.stopLoader('dataAlertCount');
      }
    }, (error) => {
      this.ngxLoader.stopLoader('dataAlertCount');
    })
  }

  getDeviceStatus(transformerList, deviceList) {
    this._dashboardService.getDeviceStatus({ "roleid": this.currentUserData.roleid, "transformerlist": transformerList, "deviceList": deviceList }).subscribe((response: any) => {
      console.log("response", response.result);
      this.deviceConnectionStatus = response.result
      let disconnected = Number(this.transformerTile.totalTransformer) - Number(response.result.length);
      console.log("response=====>", disconnected, response.result.length);
      this.deviceStatus(disconnected, response.result.length);
    });
  }

  loadProfile(transformerList) {
    this.dataLoadProfile = [];
    let finalYaxis = [];
    let sitename = [];
    let xAxis = [];
    let calYaxis = {
      firstrangeVal: 0,
      secondrangeVal: 0,
      thirdrangeVal: 0,
      fourthrangeVal: 0,
      fifthrangeVal: 0
    };

    this._dashboardService.loadProfile({ "transformerlist": transformerList }).subscribe((response: any) => {
      console.log('Transformer Data for Rated Load', response);
      if (response && response.code == '1' && response.result.length > 0) {
        this.transformerDataForHealthIndex = response.result;
        this.getTranformerHealthIndex(transformerList[0]);
        //     for (let i = 0; i < response.result.length; i++) {
        console.log('loadProfile========', response, "GroupBY==", _.groupBy(response.result, "Deviceid"))
        _.each(_.groupBy(response.result, "sitename"), (val, key) => {
          sitename.push(key);
        });
        _.each(_.groupBy(response.result, "transformerid"), (val, key) => {

          xAxis.push(key);


          if (val.length > 0) {
            let tempData: any = 0;
            for (let i = 0; i < val.length; i++) {
              let individualObj = JSON.parse(val[i].readings);
              tempData = (((Number(individualObj.L1) + Number(individualObj.L2) + Number(individualObj.L3)) / 3) / Number(val[i].ratedLoad) * 100);
              this.ratedLoadArray.push({ "transformerid": val[i].transformerid, "ratedLoad": val[i].ratedLoad });

            }
            this.LoadPercentages.push({ "transformerid": key, "data": Number(tempData) });
            finalYaxis.push(tempData);

          } else {
            let individualObj = JSON.parse(val[0].readings);
            finalYaxis.push((((individualObj.L1 + individualObj.L2 + individualObj.L3) / 3) / +val[0].ratedLoad) * 100);
          }
        });
        /*         for (let i = 0; i < response.result.length; i++) {
                  xAxis.push(response.result[i].transformerid)
                  let individualObj = JSON.parse(response.result[i].readings);
                  finalYaxis.push((((individualObj.L1 + individualObj.L2 + individualObj.L3) / 3)/+response.result[i].ratedLoad)*100);
                  //let individualloadPercentage = (individualObj.L1 + individualObj.L2 + individualObj.L3) / 3
                  //finalYaxis = this.checkRange(individualloadPercentage, calYaxis);
                } */
        console.log("yaxis=====", finalYaxis)


        //this.dataLoadProfile = [{ x: [20, 40, 60, 80, 100], y: finalYaxis, type: 'bar' }];
        this.dataLoadProfile = [{ x: xAxis, y: finalYaxis, text: sitename, type: 'bar' }];
        console.log("dataLoadProfile=====", this.ratedLoadArray)

        /* Method For Populating Tiles Count */
        // this.getTilesCount(response.result);


      } else {

      }
    }, (error) => {
      this.ngxLoader.stopLoader('kvaTile');
      this.ngxLoader.stopLoader('kwTile');
      this.ngxLoader.stopLoader('kwhTile');
    })
  }

  checkRange(individualloadPercentage, calYaxis) {

    console.log('individualloadPercentage==', individualloadPercentage)
    if (individualloadPercentage >= 0 && individualloadPercentage <= 20) {
      calYaxis.firstrangeVal = calYaxis.firstrangeVal + 1;
    }
    if (individualloadPercentage >= 21 && individualloadPercentage <= 40) {
      calYaxis.secondrangeVal = calYaxis.secondrangeVal + 1;
    }
    if (individualloadPercentage >= 41 && individualloadPercentage <= 60) {
      calYaxis.thirdrangeVal = calYaxis.thirdrangeVal + 1;
    }
    if (individualloadPercentage >= 61 && individualloadPercentage <= 80) {
      calYaxis.fourthrangeVal = calYaxis.fourthrangeVal + 1;
    }
    if (individualloadPercentage >= 81 && individualloadPercentage <= 100) {
      calYaxis.fifthrangeVal = calYaxis.fifthrangeVal + 1;
    }
    console.log('_.toArray(calYaxis)==', _.toArray(calYaxis))
    return _.toArray(calYaxis);
  }

  getTilesCount(transformerList) {
    this.ngxLoader.stopLoader('kvaTile');
    this.ngxLoader.stopLoader('kwTile');
    this.ngxLoader.stopLoader('kwhTile');
    this.readings = [];
    /* _.forEach(transformerList, (o: any) => {
       this.readings.push(JSON.parse(o.readings))
     });*/
    this.readings.push(JSON.parse(transformerList[transformerList.length - 1].readings))
    this.kvaData = {
      total: _.sumBy(this.readings, (o: any) => Number(o['3 Phase Apparent Power'])),
      max: _.maxBy(this.readings, '3 Phase Apparent Power')['3 Phase Apparent Power'],
      min: _.minBy(this.readings, '3 Phase Apparent Power')['3 Phase Apparent Power'],
      range: _.maxBy(this.readings, '3 Phase Apparent Power')['3 Phase Apparent Power'] - _.minBy(this.readings, '3 Phase Apparent Power')['3 Phase Apparent Power'],
      avg: _.sumBy(this.readings, (o: any) => Number(o['3 Phase Apparent Power'])) / transformerList.length
    };
    this.kwData = {
      total: _.sumBy(this.readings, (o: any) => Number(o['3 Phase Active Power'])),
      max: _.maxBy(this.readings, '3 Phase Active Power')['3 Phase Active Power'],
      min: _.minBy(this.readings, '3 Phase Active Power')['3 Phase Active Power'],
      range: _.maxBy(this.readings, '3 Phase Active Power')['3 Phase Active Power'] - _.minBy(this.readings, '3 Phase Active Power')['3 Phase Active Power'],
      avg: _.sumBy(this.readings, (o: any) => Number(o['3 Phase Active Power'])) / transformerList.length
    };
    this.kwhData = {
      total: _.sumBy(this.readings, (o: any) => Number(o['logSystem_Kwh'])),
      max: _.maxBy(this.readings, 'System_kwh')['System_kwh'],
      min: _.minBy(this.readings, 'System_kwh')['System_kwh'],
      range: _.maxBy(this.readings, 'System_kwh')['System_kwh'] - _.minBy(this.readings, 'System_kwh')['System_kwh'],
      avg: _.sumBy(this.readings, (o: any) => Number(o['System_kwh'])) / transformerList.length
    }
    console.log("this.kvaData====this.kwData===this.kwhData============", this.kvaData, this.kwData, this.kwhData)



  }

  getMapData(transformerList, deviceList) {
    console.log("Transformer data", transformerList)

    this.mapData = [];
    this.transformerTile = null;
    this.ngxLoader.startLoader('transformerTile');
    this._dashboardService.transformerTileData({ transformerList: transformerList }).subscribe((response: any) => {
      this.overallTransformerData = response;
      this.ngxLoader.stopLoader('transformerTile');
      if (response && response.code === '1' && response.result.length > 0) {
        this.transformerTile = response.dashboardTransformerResult;
        this.transformerStatusGraph();
        this.alertStatus();
        this.getDeviceStatus(transformerList, deviceList);
        this.lat = response.result[0].siteData.latitude;
        this.lng = response.result[0].siteData.longitude;
        this.mapData = _.flatMap(response.result, (o: any) => {
          for (let l = 0; l < o.alert.lenght; l++) {
            if (o.alert[l].parametername == 'apOiltemperature') {
              this.oilTempsum = this.oilTempsum + 1;
            }
          }

          let tempMapData: any = {};
          tempMapData.transformerid = o.siteData.transformerid;
          tempMapData.latitude = o.siteData.latitude;
          tempMapData.longitude = o.siteData.longitude;
          tempMapData.sitename = o.siteData.sitename;
          tempMapData.datareceived = o.datareceived;
          if (o.datareceived) {
            let readings = JSON.parse(o.transformerData.readings);
            tempMapData.Kva = (+readings['3 Phase Apparent Power']).toFixed(2);
            tempMapData.Kwh = readings.System_kwh;
            tempMapData.Load = (((readings.L1 + readings.L2 + readings.L3) / 3) / o.transformerData.ratedLoad) * 100;
          } else if (o.datareceivedafter) {
            let readings = JSON.parse(o.transformerData.readings);
            tempMapData.Kva = (+readings['3 Phase Apparent Power']).toFixed(2);
            tempMapData.Kwh = readings.System_kwh;
            tempMapData.Load = (((readings.L1 + readings.L2 + readings.L3) / 3) / o.transformerData.ratedLoad) * 100;
          } else {
            tempMapData.Kva = null;
            tempMapData.Kwh = null;
            tempMapData.Load = null;
          }
          tempMapData.alert = _.map(o.alert, (a: any) => {
            a.mparametervalue = a.gparametervalue;
            if (a.parametername === "apOillevel") {
              if (a.mparametervalue === 4) { a.mparametervalue = "Low"; }
              if (a.mparametervalue === 5) { a.mparametervalue = "Medium"; }
              if (a.mparametervalue === 6) { a.mparametervalue = "High"; }
            }
            return a;
          });
          return tempMapData;
        });
        console.log("overlall data >>>>>>>>>>", this.overallTransformerData)
        let loadData = this.overallTransformerData.result;
        let loadDataArray = [];
        let demandArray = [];
        let max = 0;
        let maxdemand = 0;
        let currentDate = moment(moment().format('YYYY-MM-DD HH:mm:ss'));
        let DisconnectedDevices = [];
        loadData.forEach(element => {
          if (element.hasOwnProperty("datareceivedafter")) {
            DisconnectedDevices.push(element.transformerid);
          }
          if (element.hasOwnProperty("transformerData")) {
            let JsonReadings = JSON.parse(element.transformerData.readings);
            let trafoLoadData = (((Number(JsonReadings.L1) + Number(JsonReadings.L2) + Number(JsonReadings.L3)) / 3) / Number(element.transformerData.ratedLoad) * 100);
            let demandData = (Number(JsonReadings['3 Phase Active Power']));
            demandArray.push(demandData);
            loadDataArray.push(trafoLoadData);
            let checkIsOffline = moment(moment(element.transformerData.latestDATE).format('YYYY-MM-DD HH:mm:ss'));
            let duration = moment.duration(currentDate.diff(checkIsOffline));
            if (duration.minutes() < 20) {
              if (demandData > maxdemand) {
                maxdemand = demandData;
                this.maxDemand = "Transformer ID: " + element.transformerData.transformerid + "[" + element.siteData.sitename + "]";

              }

            }
            if (trafoLoadData > max) {
              max = trafoLoadData
              this.maxTransformerId = "Transformer ID: " + element.transformerData.transformerid + "[" + element.siteData.sitename + "]";
            }

            if (element.alert.length >= 3) {
              let alertData = [];
              let warningData = ` Transformer ${element.transformerid}[${element.siteData.sitename}] is experiencing issues, including `
              element.alert.forEach(values => {
                if (!alertData.includes(values.parametername))
                  alertData.push(values.parametername);
              })

              if (alertData.length >= 3) {
                alertData.forEach(dataValue => {
                  warningData += dataValue.replace(/^ap/, '') + ", ";
                })
                this.warningDataArray.push(warningData)
              }
            }
          }
        });
        console.log("Disconnected Devices", DisconnectedDevices)
        this.maxDemandValue = maxdemand.toFixed(0);

        let sumDemand = demandArray.reduce((acc, num) => acc + num, 0);
        const count = demandArray.filter(num => num !== 0).length;
        this.averageDemand = Number(sumDemand / count).toFixed(0);
        const sum = loadDataArray.reduce((acc, num) => acc + num, 0);
        const average = sum / loadDataArray.length;
        this.loadAverageGraph(average.toFixed(1));
        this.peakLoadGraph(max.toFixed(1));

        //this.status(this.mapData[0].transformerid);
      }
    }, (error) => {
      this.ngxLoader.stopLoader('transformerTile');
    });
  }

  getWeatherData(data) {
    //let response = JSON.parse('{"coord":{"lon":72.85,"lat":19.01},"weather":[{"id":721,"main":"Haze","description":"haze","icon":"50n"}],"base":"stations","main":{"temp":297.15,"feels_like":297.4,"temp_min":297.15,"temp_max":297.15,"pressure":1013,"humidity":69},"visibility":3500,"wind":{"speed":3.6,"deg":300},"clouds":{"all":20},"dt":1580141589,"sys":{"type":1,"id":9052,"country":"IN","sunrise":1580089441,"sunset":1580129884},"timezone":19800,"id":1275339,"name":"Mumbai","cod":200}');
    let responseWeather;
    this._dashboardService.getWeatherData(data).subscribe((response: any) => {
      if (response) {
        console.log("responseWeather==Weather==", response)
        responseWeather = response;
        this.weatherData = {
          location: _.startCase(data.locationname),
          city: _.startCase(data.cityname),
          state: _.startCase(data.statename),
          country: _.startCase(data.countryname),
          temperature: (responseWeather.main.temp - 273.15).toFixed(2),
          weatherType: responseWeather.weather[0].main,
          wind: responseWeather.wind.speed * 3.6,
          humidity: responseWeather.main.humidity,
        }
        console.log("this.weatherData==Weather==", this.weatherData)
      }
    });

  }
  async filters(type: string, param: string) {

    try {
      console.log(type, param);
      if (type === 'date') {
        this.timeFilter = param;
        //  if (Object.keys(this.filter).length > 0) {

        var filter: any = await this.formatDate(param);
        //this.filter = this.filter + filter;
        if (filter.filter === 'This Week' || filter.filter === 'This Month' || filter.filter === 'Last Month') {
          if (this.filter && this.filter.date) {
            delete this.filter.date;
          }
          this.filter.startDate = filter.startDate;
          this.filter.endDate = filter.endDate;
          this.filter.filter = filter.filter;
        }
        else if (filter.filter === 'Today' || filter.filter === 'Yesterday') {
          if (this.filter && this.filter.startDate && this.filter.endDate) {
            delete this.filter.startDate;
            delete this.filter.endDate;
          }
          this.filter.filter = filter.filter
          this.filter.date = filter.date;
        }

        else if (filter.filter === 'Custom') {
          if (this.filter && this.filter.date) {
            delete this.filter.date;
          }
          if (filter.startDate && filter.endDate) {
            this.filter.startDate = filter.startDate;
            this.filter.endDate = filter.endDate;
            this.filter.filter = filter.filter;
          }

        }
        if (filter.startDate && filter.endDate) {
        }
      }


    } catch (error) {
      console.log('ERROR:', error);
    }


  }

  formatDate(param) {
    return new Promise((resolve, reject) => {
      if (param === 'Today') {
        var d = new Date(),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2)
          month = '0' + month;
        if (day.length < 2)
          day = '0' + day;
        resolve({ 'date': [year, month, day].join('-'), 'filter': param })
        // return [year, month, day].join('-');
      } else if (param === 'Yesterday') {
        var d = new Date(),
          month = '' + (d.getMonth() + 1),
          day = '' + (d.getDate() - 1),
          year = d.getFullYear();

        if (month.length < 2)
          month = '0' + month;
        if (day.length < 2)
          day = '0' + day;
        resolve({ 'date': [year, month, day].join('-'), 'filter': param });
        //return [year, month, day].join('-');
      } else if (param === 'Last Month') {
        resolve({ 'startDate': moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), 'endDate': moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'), 'filter': param })
        // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);
        // resolve({'startDate':[year, month, day].join('-'), 'endDate':[year, month, 30].join('-')});
      }
      else if (param === 'This Month') {
        resolve({ 'startDate': moment().startOf('month').format('YYYY-MM-DD'), 'endDate': moment().endOf('month').format('YYYY-MM-DD'), 'filter': param });
        // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);

      } else if (param === 'This Week') {
        resolve({ 'startDate': moment().startOf('week').format('YYYY-MM-DD'), 'endDate': moment().endOf('week').format('YYYY-MM-DD'), 'filter': param })
        //  resolve('&' + `startDate=${[year, month, startDate].join('-')}` + '&' + `endDate=${[year, month, day].join('-')}` +  '&' + `filter=${param}`);
      }
      else if (param === 'Custom') {
        const dialogConfig = new MatDialogConfig();
        let dialogRef = this.matDialog.open(CustomDateComponent, {
          autoFocus: false,
          height: '350px', width: '450px', data: { "details": "", "action": "Add", selectedDate: this.customeSelectedDate }
        });


        dialogRef.afterClosed().subscribe(value => {
          console.log("Value=======", value);
          this.customeSelectedDate = value;
          resolve({ 'startDate': value.startDate, 'endDate': value.endDate, 'filter': param })
        });
      }
    })
  }
  getTapPosition(transformerid) {
    this._dashboardService.getTapPositionData(transformerid).subscribe((response: any) => {
      let tap = [];
      for (let j = 1; j < response.result.length; j++) {
        if (response.result[j - 1].Tap_Position != response.result[j].Tap_Position) {
          tap.push(response.result[j - 1].Tap_Position);
          console.log("kjsdhfhsuidfu", tap)
        } else {

        }
      }
      this.counter = tap.length + 1;
    });
  }
  loadLeafletMap() {
    if (this.map) {
      this.map.remove();
    }
    this.map = L.map('leafletMap', { fullscreenControl: true }).setView([this.lat1, this.lng1], 4);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '©Bola'
    }).addTo(this.map);
    this.map.attributionControl.setPrefix(false);
    // this.map.attributionControl.remove();
    this.mapData.forEach((data: any) => {
      const icon = L.icon({
        iconUrl: data.datareceived && data.alert.length === 0
          ? this.greenTransformerPath
          : data.datareceived && data.alert.length > 0
            ? this.redTransformerPath
            : this.blackTransformerPath,
        iconSize: [30, 30],
        iconAnchor: [15, 30]
      });
      const marker = L.marker([data.latitude, data.longitude], { icon }).addTo(this.map);
      let popupContent = `
      <p><strong>Transformer Id:</strong> ${data.transformerid}</p>
      <p><strong>Site Name:</strong> ${data.sitename}</p>
      ${data.datareceived
          ? '<p style="color:green;">Power: On</p>'
          : '<p style="color:red;">Power: Off</p>'}
      ${data.alert.length > 0
          ? '<p style="color:red;">' + data.alert.map(param => `${param.parametername.slice(2)}: ${param.mparametervalue}`).join('<br>') + '</p>'
          : ''}
    `;
      marker.bindTooltip(popupContent, {
        direction: 'top',
        sticky: true,
        opacity: 1.8
      });
      marker.on('click', () => {
        this.transformerClicked(data);
      });
    });
  }

  getTranformerHealthIndex(transformerID) {
    this.status(transformerID)
    this.getTapPosition(transformerID)
    this.oilTempValues = 0;
    this.windingTempValues = 0;
    this.oilLevelValues = 0;
    this.healthOfTransformer = 0;
    this.loadPercentageValue = 0;
    this.oilLevelIndicator = '0';
    let OilTempDataGraph = [];
    let windTempDataGraph = [];
    let OilLevelDataGraph = [];
    let ambeintDataGraph = [];
    let loadGraphData = [];
    let allGraphDate = [];
    this._dashboardService.getTransformerHealthIndex(transformerID).subscribe((response: any) => {
      for (let i = 0; i < this.LoadPercentages.length; i++) {
        if (this.LoadPercentages[i].transformerid == transformerID) {
          this.loadPercentageValue = Number(this.LoadPercentages[i].data).toFixed(2);
          loadGraphData.push(Number(this.LoadPercentages[i].data).toFixed(2));
          if (isNaN(this.loadPercentageValue)) {
            this.loadPercentageValue = 0;
          }
        }
      }
      /*this.chart3.updateOptions({
        series: [
          this.loadPercentageValue
        ]
      });*/
      this._dashboardService.parameterConfig(transformerID).subscribe((response1: any) => {
        let oilTempDataFlag = false;
        let oilLevelDataFlag = false;
        let lugTempDataFlag = false;
        if (response1.result.length > 0) {
          console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>Test Data", this.transformerDataForHealthIndex);
          for (let i = 0; i < this.transformerDataForHealthIndex.length; i++) {

            if (this.transformerDataForHealthIndex[i].transformerid == transformerID) {
              if (response1.result[0].oiltemperature == '1') {
                this.oilTempValues = this.transformerDataForHealthIndex[i].Oil_Temperature;
                this.ambeintTempValues = this.transformerDataForHealthIndex[i].Ambient_Temperature
                OilTempDataGraph.push(this.transformerDataForHealthIndex[i].Oil_Temperature);
                allGraphDate.push(this.transformerDataForHealthIndex[i].date)
                const dateString = this.transformerDataForHealthIndex[i].DATE;

                /* this.chart1.updateOptions({
                   series: [
                     this.transformerDataForHealthIndex[i].Oil_Temperature
                    ]
                 })*/
                oilTempDataFlag = true;
              }
              if (response1.result[0].lugtemp == '1') {
                let data = JSON.parse(this.transformerDataForHealthIndex[i].readings);
                lugTempDataFlag = true;
              }
              if (response1.result[0].windingtemperature == '1') {
                if (this.transformerDataForHealthIndex[i].hasOwnProperty("Winding_Temperature")) {
                  this.windingTempValues = this.transformerDataForHealthIndex[i].Winding_Temperature;
                  windTempDataGraph.push(this.transformerDataForHealthIndex[i].Winding_Temperature)
                }
              }
              if (this.transformerDataForHealthIndex[i].Winding_Temperature < 0) {
                this.windingTempValues = 0;
              }
              if (response1.result[0].oillevel == '1') {
                if (this.transformerDataForHealthIndex[i].Oil_Level == 4) {
                  this.oilLevelValues = 20;
                  this.oilLevelIndicator = "LOW";
                } else if (this.transformerDataForHealthIndex[i].Oil_Level == 5) {
                  this.oilLevelValues = 50;
                  this.oilLevelIndicator = "MEDIUM"
                } else if (this.transformerDataForHealthIndex[i].Oil_Level == 6) {
                  this.oilLevelValues = 90;
                  this.oilLevelIndicator = "HIGH";
                } else {
                  this.oilLevelIndicator = this.transformerDataForHealthIndex[i].Oil_Level + '%';
                  this.oilLevelValues = Number(this.transformerDataForHealthIndex[i].Oil_Level);
                }
                // this.UpdateOilLevelGraph(this.oilLevelValues,this.oilLevelIndicator);
                oilLevelDataFlag = true;
                OilLevelDataGraph.push(Number(this.transformerDataForHealthIndex[i].Oil_Level));
              }
              if (response1.result[0].windingtemperaturebycal == '1') {
                if (this.transformerDataForHealthIndex[i].Oil_Temperature !== 0 && this.windingTempValues == 0) {
                  var jsonReadings = JSON.parse(this.transformerDataForHealthIndex[i].readings);
                  var addition: number = Number(jsonReadings.L1) + Number(jsonReadings.L2) + Number(jsonReadings.L3);
                  var LoadPercentage: number = ((addition / 3) / Number(this.transformerDataForHealthIndex[i].kvarating)) * 100;
                  this.windingTempValues = Number((Number(this.transformerDataForHealthIndex[i].Oil_Temperature) + ((this.transformerDataForHealthIndex[i].kwhreading * LoadPercentage) / 100)).toFixed(2));
                  windTempDataGraph.push(this.windingTempValues)
                  if (isNaN(this.windingTempValues)) {
                    this.windingTempValues = 0;
                  }
                }
              }
              if (this.currentUserData.userid == 233) {
                this.updateAllComparisionGraph({ oil: OilTempDataGraph, wind: windTempDataGraph, date: allGraphDate })
              }
            }
          }
          this.hotSpotCalculation();
          let color = '#008000';
          if (this.windingTempValues > 105) {
            color = '#FF0000'
          }
          /*this.chart2.updateOptions({
           
            series: [
              this.windingTempValues
            ],
            colors:[color]
          });*/
          console.log("Calculated Winding Tempareture value", this.calculatedWindingTemprature);
          if (response.data.length > 0) {
            this.healthOfTransformer = response.data[0].percentage;
            this.dataforHealthIndex = response.data[0].alldata;
            if (this.healthOfTransformer >= 85) {
              this.healthColor = "green";
            } else if (this.healthOfTransformer < 85 && this.healthOfTransformer >= 70) {
              this.healthColor = "orange";
            } else if (this.healthOfTransformer < 70) {
              this.healthColor = "red";
            }
            /* this.healthIndexObject.updateOptions({
               series: [
                 this.healthOfTransformer
               ]
             });*/
          }
        }
        /*if(!oilTempDataFlag){
          this.chart1.updateOptions({
            series: [
             0
            ]
          });
        }*/
        if (!oilLevelDataFlag) {
          this.UpdateOilLevelGraph(0, "No Data");
        }

      });

    });
  }
  updateAllComparisionGraph(data) {
    console.log(">/???////////", data)
    this.comparision.updateOptions({
      series: [
        { data: data.oil },
        { data: data.wind }
      ]
    });
  }
  UpdateOilLevelGraph(value, label) {
    let color = '#008000';
    if (value < 25) {
      color = '#FF0000';
    } else if (value > 60) {
      color = '#FFA500';
    }
    this.oilLevelGraphObject.updateOptions({
      series: [
        value
      ],
      plotOptions: {
        radialBar: {
          dataLabels: {
            value: {
              formatter: function (val, opts) {
                return label; // Use the updated oilLevelIndicator
              }
            }
          }
        }
      },
      colors: [color]
    });
  }
  updateLugTempGraph(data) {
    console.log(data)
    this.lugTempGraphObject.updateOptions({
      series: [
        data.Lug_Temp_R, data.Lug_Temp_Y, data.Lug_Temp_B
      ],
      plotOptions: {
        radialBar: {
          dataLabels: {
            value: {
              formatter: function (seriesName, opts) {
                return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "°C"
              }
            }
          }
        }
      }
    });
  }
  transformerSelectionWeather(selectedTransformer) {
    if (this.selectedTransformerForWeather) {
      this.getWeatherData(selectedTransformer);
    }
  }
  getLastUpdatedAlertsData() {
    this._dashboardService.getLastUpdatedAlertsData({
      userid: this.currentUserData.userid,
      roleid: this.currentUserData.roleid
    }).subscribe((response: any) => {
      console.log("live alerts", response);
      console.log("Expired Transformer", this.amcexpiredtransformer);

      if (response.result.length > 0) {
        // filter out expired transformer IDs before pushing
        const filteredData = response.result.filter(
          item => !this.amcexpiredtransformer.includes(item.transformerid) // ignore expired ones
        );

        this.latestAlertsArray = this.latestAlertsArray.concat(filteredData);
      }
    });
  }

  popupTable(state, selected) {
    console.log('data==edit==', state);
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.height = '80%';
    dialogConfig.width = '70%';
    console.log("gyugyuyugyggi--hgjhhghh", this.overallTransformerData)
    if (this.overallTransformerData !== undefined) {

      if (state == 'Disconnected') {
        this.overallTransformerData.result.forEach(itemA => {
          // Check if there is a match in `deviceConnectionStatus`
          let isMatched = this.deviceConnectionStatus.some(itemB => itemA.transformerid == itemB.id);

          if (isMatched) {
            console.log("itemA.transformerid", itemA.transformerid);
            itemA.deviceStatus = false;
          }
        });
      }
      if (state == 'Connected') {
        this.overallTransformerData.result.forEach(itemA => {
          // Check if there is a match in `deviceConnectionStatus`
          let isMatched = this.deviceConnectionStatus.some(itemB => itemA.transformerid == itemB.id);

          if (!isMatched) {
            console.log("itemA.transformerid", itemA.transformerid);
            itemA.deviceStatusConnected = true;
          }
        });
      }
      if (state == 'Healthy') {
        this.overallTransformerData.result.forEach(itemA => {
          // Check if there is a match in `deviceConnectionStatus`
          let isMatched = this.Healthy.some(itemB => itemA.transformerid == itemB);

          if (isMatched) {
            console.log("itemA.transformerid", itemA.transformerid);
            itemA.healthStatus = true;
          }
        });
      }
      if (state == 'Average') {
        this.overallTransformerData.result.forEach(itemA => {
          // Check if there is a match in `deviceConnectionStatus`
          let isMatched = this.averageHealth.some(itemB => itemA.transformerid == itemB);

          if (isMatched) {
            console.log("itemA.transformerid", itemA.transformerid);
            itemA.AvghealthStatus = true;
          }
        });
      }
      if (state == 'Unhealthy') {
        this.overallTransformerData.result.forEach(itemA => {
          // Check if there is a match in `deviceConnectionStatus`
          let isMatched = this.Unhealthy.some(itemB => itemA.transformerid == itemB);

          if (isMatched) {
            console.log("itemA.transformerid", itemA.transformerid);
            itemA.UnhealthStatus = true;
          }
        });
      }
      if (state == 'completeMaintenance') {
        this.overallTransformerData.result.forEach(itemA => {
          // Check if there is a match in `deviceConnectionStatus`
          let isMatched = this.completeMaintenanceData.some(itemB => itemA.transformerid == itemB);

          if (isMatched) {
            console.log("itemA.transformerid", itemA.transformerid);
            itemA.completeMaintenanceStatus = true;
          }
        });
      }
      if (state == 'pendingMaintenance') {
        this.overallTransformerData.result.forEach(itemA => {
          // Check if there is a match in `deviceConnectionStatus`
          let isMatched = this.pendingMaintenanceData.some(itemB => itemA.transformerid == itemB);

          if (isMatched) {
            console.log("itemA.transformerid", itemA.transformerid);
            itemA.pendingMaintenanceStatus = true;
          }
        });
      }
      dialogConfig.data = {
        type: state,
        currentUserData: this.currentUserData,
        TransformerData: this.overallTransformerData
      };
      if (selected == "alertDataSelected") {
        dialogConfig.data['selected'] = selected;
      }
      if (selected == "helathCenterDataSelected") {
        dialogConfig.data['selected'] = selected;
      }
      let dialogRef = this.matDialog.open(PopuptableComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((response) => {
      })
    }
  }
  popupAlertsTable() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.height = '90%';
    dialogConfig.width = '90%';
    dialogConfig.data = {
      type: "AlertsTable",
      currentUserData: this.currentUserData,
    };
    this.dialogRefas = this.matDialog.open(AlertpopuptableComponent, dialogConfig);
  }
  status(transformerid) {
    this.mapData.forEach(data => {
      if (transformerid == data.transformerid) {
        console.log("Inside data", data)
        if (data.datareceived && data.alert.length == 0) {
          this.imgPath = this.greenTransformerPath;
          this.batteryStatusImgUrl = "assets/images/fullbattery.png";
        } else if (data.datareceived && data.alert.length > 0) {
          this.imgPath = this.redTransformerPath
          this.batteryStatusImgUrl = "assets/images/fullbattery.png";
          console.log("b./////////./.")
        } else {
          this.imgPath = this.blackTransformerPath
          this.batteryStatusImgUrl = "assets/images/lowbattery.png";
        }
        if (data.Kwh === "000") {
          this.imgPath = this.blackTransformerPath;
          this.batteryStatusImgUrl = "assets/images/fullbattery.png";
        }
      }
    });
  }
  open_individual(TransformerID) {
    // console.log(TransformerID)
    // this.router.navigate(['/#/individual-status/', { transformerId: TransformerID} ]);
    this.router.navigate(['digitalTwin/'], { queryParams: { transformerId: TransformerID } });
  }
  getRenewalData() {
    console.log("getRenewalData called", this.allTransformers);

    this._dashboardService.getRenewalDate(this.currentUserData.userid).subscribe((response: any) => {
      if (response.result.length > 0) {

        const expiredList = this.allTransformers.filter(t => t.amc_status === "Expired" || t.dashboard_access === 0);
        const activeList = this.allTransformers.filter(t => t.amc_status !== "Expired" && t.dashboard_access !== 0);

        if (expiredList.length > 0) {

          if (activeList.length === 0) {
            let domObject = document.getElementById("denyDashboardAccess");
            domObject.style.opacity = '0.0';
            this.matDialog.open(RenewalWindowComponent, {
              autoFocus: false,
              height: '85%',
              width: '50%',
              data: { data: response.result, amount: this.transformerList },
              disableClose: true,
              panelClass: 'custom-dialog-container'
            });
          }
          else {

            this.matDialog.open(RenewalWindowComponent, {

              autoFocus: false,
              height: '85%',
              width: '50%',
              data: { data: response.result, amount: this.allTransformers },
              disableClose: false,
              panelClass: 'custom-dialog-container'
            });
          }
        }

        // ✅ Case 3: sabhi active → kuch nahi karna
      }
    });
  }
  hotSpotCalculation() {
    let oilTempRise = Number(this.oilTempValues) * (1.2) * 0.9;
    let hotspotGradient = 15 * (1.2) * 0.9;
    let ambientTemp = this.ambeintTempValues;
    this.hotSpotCalculationValue = Number(ambientTemp + oilTempRise + hotspotGradient).toFixed(2);
    console.log("temp Hotspot calc/[[[[[", this.hotSpotCalculationValue);
  }


}
